<template>
    <div>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Indicadores financieros</h4>
        </div>
        <card  class="form-horizontal">
            <div class="card-header"></div>
            <div class="card-body">
                <el-table :data="data" ref="productsTable">
                    <el-table-column label="Indicador" property="name"></el-table-column>
                    <el-table-column label="Valor">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.value)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="card-footer"></div>
        </card>
        <div class="row">
            <div  v-for="stats in percentCards" :key="stats.id" class="col-lg-4 col-md-6 col-sm-12">
                <circle-chart-card :percentage="stats.value"
                                :chart-id="stats.id"
                                :title="stats.title"
                                color="#F09500">
                </circle-chart-card>
            </div>
        </div>
        <div class="text-right">
            <p-button @click="toFinish()" type="warning">Siguiente</p-button>
            <p-button @click="toCharacterAnalysisChart()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import VueScrollTo from 'vue-scrollto'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import StatsCard from 'src/components/UIComponents/Cards/StatsCard'
    import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn} from 'element-ui'
    import CharacterAnalysis from 'src/util/CharacterAnalysis/CharacterAnalysis'
    import PProgress from 'src/components/UIComponents/Progress.vue'
    import moment from 'moment'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            StatsCard,
            CircleChartCard,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            PProgress,
        },
        data() {
        return {
            statsCards: [                
            ],
            statsCards2: [                           
            ],
            percentCards: [
                {
                    value: 0,
                    id: 'cobertura',
                    title: 'Cobertura de la cuota',
                },
            ],
            data: [
                {
                    name: 'Total ingresos',
                    value: 0,
                },
                {
                    name: 'Excedente familiar',
                    value: 0,
                },
                {
                    name: 'Ingresos por salarios',
                    value: 0,
                },
                {
                    name: 'Capacidad de pago',
                    value: 0,
                },
            ],
            categories: [],
            modelValidations: {
                statement : {
                    required: true
                }
            },
        }
        },
        watch: {

        },
        computed: {
        },
        methods: {
            validateAgroSpouse () {
                var vm = this;
                if (vm.$store.state.isSpouse) {
                    var firstProduct = vm.$store.getters.getProductTypes.find(product => product.id == vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.studies[0].productType)
                    if(firstProduct.name.toLowerCase() == 'agropecuario'){
                        let salary = vm.$store.state.assesments[vm.$store.state.actualAssesment].customerSpouse.studies[0].netSalary;
                        let clientTerm =  vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.studies[0].agroData.cashFlow.clientTerm || 0;
                        let totalSalary = (parseFloat(salary) * parseFloat(clientTerm)) || 0;
                        let spouseBalance = {
                            spouseName: 'Salario Cónyuge',
                            spouseValue : salary,
                            spouseTotal : totalSalary
                        }
                        vm.$store.dispatch('setSpouseBalance', spouseBalance).then(()=>{
                            console.log('Datos almacenados correctamente');
                        });
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toBalance () {
                this.$router.push('/asessments/new_asessment/customer/others/additional_information');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toOperatingExpenses () {
                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toCharacterAnalysisChart () {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy == 0) {
                    this.$router.push('/asessments/new_asessment/customer/others/character_analysis_chart');
                }
                else {
                    this.$router.push('/asessments/new_asessment/customer/others/consumer_additional_information');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toFinish () {
                var vm = this;
                // if(vm.$store.state.assesments[vm.$store.state.actualAssesment].hasOwnProperty('created_at') == true) {
                //     vm.$store.state.assesments[vm.$store.state.actualAssesment].created_at = moment().format(); 
                // }
                if (vm.$store.state.isCustomer) {
                    swal({
                    title: '¿Deseas agregar otro estudio?',
                    text: 'Si aceptas, iniciarás otro estudio para el mismo cliente',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, aceptar',
                    cancelButtonText: 'No, continuar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    vm.$store.dispatch('newStudy', 'customer').then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/request_data');
                    });
                    
                }, function (dismiss) {
                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                        if (dismiss == 'cancel') {
                            if (vm.$store.state.assesments[vm.$store.state.actualAssesment].customer.actualStudy == 0) {
                                if (vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors.length > 0 && vm.$store.state.assesments[vm.$store.state.actualAssesment].guarantors[0].studies.length > 0) {
                                    swal({
                                        title: 'Codeudor encontrado',
                                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                        text: 'Hemos encontrado que agregaste un codeudor, puedes eliminar los codeudores o continuar al menú',
                                        type: 'warning',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, eliminar',
                                        cancelButtonText: 'No, ir al menú',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        vm.$store.dispatch('deleteGuarantors').then(()=>{
                                            vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                    vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                            });
                                        });
                                        
                                    }, function (dismiss) {
                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                        if (dismiss == 'cancel') {
                                            vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                vm.$store.dispatch('setActualAssesment', vm.$store.state.syncAssessment).then(()=>{
                                                    vm.$router.push('/asessments/menu');
                                                });
                                            });
                                        }
                                        else {
                                            swal({
                                                title: 'Cancelado',
                                                text: 'El analista no ha continuado',
                                                type: 'error',
                                                confirmButtonClass: 'btn btn-info btn-fill',
                                                buttonsStyling: false
                                            })
                                        }
                                    })
                                    // vm.$router.push('/asessments/menu');
                                }
                                else {
                                        swal({
                                            title: '¿Deseas agregar un estudio del cónyuge del titular?',
                                            text: 'Si aceptas, agregarás o editarás el cónyuge al titular de la evaluación',
                                            type: 'warning',
                                            showCancelButton: true,
                                            confirmButtonText: 'Si, aceptar',
                                            cancelButtonText: 'No, continuar',
                                            confirmButtonClass: 'btn btn-success btn-fill',
                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                            buttonsStyling: false
                                        }).then(() => {
                                            vm.$store.dispatch('newSpouse').then(()=>{
                                                vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                            });
                                            
                                        }, function (dismiss) {
                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                            if (dismiss == 'cancel') {
                                                swal({
                                                    title: '¿Deseas agregar un codeudor?',
                                                    // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                    text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                    type: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Si, aceptar',
                                                    cancelButtonText: 'No, continuar',
                                                    confirmButtonClass: 'btn btn-success btn-fill',
                                                    cancelButtonClass: 'btn btn-danger btn-fill',
                                                    buttonsStyling: false
                                                }).then(() => {
                                                    vm.$store.dispatch('newGuarantor').then(()=>{
                                                        vm.$router.push('/asessments/new_asessment/customer/personal_data');
                                                    });
                                                    
                                                }, function (dismiss) {
                                                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                    if (dismiss == 'cancel') {
                                                        swal({
                                                            title: '¿Deseas agregar información al FM102?',
                                                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                                            text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                                            type: 'warning',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Si, aceptar',
                                                            cancelButtonText: 'No, continuar',
                                                            confirmButtonClass: 'btn btn-success btn-fill',
                                                            cancelButtonClass: 'btn btn-danger btn-fill',
                                                            buttonsStyling: false
                                                        }).then(() => {
                                                            var payload = {
                                                                client: 'customer',
                                                                actualAssesment: vm.$store.state.actualAssesment,
                                                                actualStudy: 0
                                                            }
                                                            var payload2 = {
                                                                stage: 'Finalización',
                                                                description: 'Se finaliza la evaluación.',
                                                                dateTime: moment().format()
                                                            };
                                                            vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                                                vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                    vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                                                        vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                                            vm.$router.push('/asessments/new_asessment/customer/fm102');
                                                                        });                    
                                                                    });
                                                                });
                                                            });
                                                            
                                                        }, function (dismiss) {
                                                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                                            var payload = {
                                                                stage: 'Finalización',
                                                                description: 'Se finaliza la evaluación.',
                                                                dateTime: moment().format()
                                                            };
                                                            vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                                                vm.$store.dispatch('finishEvaluation', 'customer').then(()=>{
                                                                        vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                                                });
                                                            });
                                                        })
                                                        
                                                    }
                                                    else {
                                                        swal({
                                                            title: 'Cancelado',
                                                            text: 'El analista no ha finalizado',
                                                            type: 'error',
                                                            confirmButtonClass: 'btn btn-info btn-fill',
                                                            buttonsStyling: false
                                                        })
                                                    }
                                                })
                                            }
                                            else {
                                                swal({
                                                    title: 'Cancelado',
                                                    text: 'El analista no ha finalizado',
                                                    type: 'error',
                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                    buttonsStyling: false
                                                })
                                            }
                                        })
                                }
                            }
                            else {
                                vm.$router.push('/asessments/new_asessment/customer/others/additional_information_consolidated');
                            }
                        }
                        else {
                            swal({
                                title: 'Cancelado',
                                text: 'El analista no ha finalizado',
                                type: 'error',
                                confirmButtonClass: 'btn btn-info btn-fill',
                                buttonsStyling: false
                            })
                        }
                    })
                }
                else if (vm.$store.state.isSpouse) {
                    this.validateAgroSpouse();
                    swal({
                        title: '¿Deseas agregar un codeudor?',
                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                        text: 'Si aceptas, agregarás un codeudor a la evaluación',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Si, aceptar',
                        cancelButtonText: 'No, continuar',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        cancelButtonClass: 'btn btn-danger btn-fill',
                        buttonsStyling: false
                    }).then(() => {
                        vm.$store.dispatch('newGuarantor').then(()=>{
                            vm.$router.push('/asessments/new_asessment/customer/personal_data');
                        });
                        
                    }, function (dismiss) {
                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                        if (dismiss == 'cancel') {
                            swal({
                                title: '¿Deseas agregar información al FM102?',
                                // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonText: 'Si, aceptar',
                                cancelButtonText: 'No, continuar',
                                confirmButtonClass: 'btn btn-success btn-fill',
                                cancelButtonClass: 'btn btn-danger btn-fill',
                                buttonsStyling: false
                            }).then(() => {
                                var payload = {
                                    client: 'customer',
                                    actualAssesment: vm.$store.state.actualAssesment,
                                    actualStudy: 0
                                }
                                var payload2 = {
                                    stage: 'Finalización',
                                    description: 'Se finaliza la evaluación.',
                                    dateTime: moment().format()
                                };
                                vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                                    vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                        vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                            vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                                vm.$router.push('/asessments/new_asessment/customer/fm102');
                                            });                    
                                        });
                                    });
                                });
                                
                            }, function (dismiss) {
                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                var payload = {
                                    stage: 'Finalización',
                                    description: 'Se finaliza la evaluación.',
                                    dateTime: moment().format()
                                };
                                vm.$store.dispatch('setChangeLog', payload).then(()=>{
                                    vm.$store.dispatch('finishEvaluation', 'spouse').then(()=>{
                                        vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                                    });
                                });
                            })
                        }
                        else {
                            swal({
                                title: 'Cancelado',
                                text: 'El analista no ha finalizado',
                                type: 'error',
                                confirmButtonClass: 'btn btn-info btn-fill',
                                buttonsStyling: false
                            })
                        }
                    })
                }
                if (vm.$store.state.isGuarantor) {
                    swal({
                        title: '¿Deseas agregar información al FM102?',
                        // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                        text: 'Si aceptas, agregarás o editarás información del formulario FM102',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Si, aceptar',
                        cancelButtonText: 'No, continuar',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        cancelButtonClass: 'btn btn-danger btn-fill',
                        buttonsStyling: false
                    }).then(() => {
                        var payload = {
                            client: 'guarantor',
                            actualAssesment: vm.$store.state.actualAssesment,
                            actualStudy: 0
                        }
                        var payload2 = {
                            stage: 'Finalización',
                            description: 'Se finaliza la evaluación.',
                            dateTime: moment().format()
                        };
                        vm.$store.dispatch('setChangeLog', payload2).then(()=>{
                            vm.$store.dispatch('finishEvaluation', 'guarantor').then(()=>{
                                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                                        vm.$router.push('/asessments/new_asessment/customer/fm102');
                                    });                    
                                });
                            });
                        });
                        
                    }, function (dismiss) {
                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                        var payload = {
                            stage: 'Finalización',
                            description: 'Se finaliza la evaluación.',
                            dateTime: moment().format()
                        };
                        vm.$store.dispatch('setChangeLog', payload).then(()=>{
                            vm.$store.dispatch('finishEvaluation', 'guarantor').then(()=>{
                                    vm.$router.push('/asessments/new_asessment/customer/others/assesment_sync'); 
                            });
                        });
                    })
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveReferences () {
                if (this.products.length != 0) {
                    this.$store.dispatch('setReferences', this.products).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                    });
                }
                else {
                    this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                }
            }
        },
        mounted () {
            if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance.length != 0) {
                var storageFinancialIndicators = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].i.financialIndicators;
                var storagePaymentCapacity = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].balance[0].cp.paymentCapacity;
                this.data[0].value = storagePaymentCapacity[0].value;
                this.data[1].value = storagePaymentCapacity[1].value;
                this.data[2].value = storagePaymentCapacity[2].value;
                this.data[3].value = storagePaymentCapacity[3].value;
                for (let i=0;i<storageFinancialIndicators.length;i++) {
                    if(storageFinancialIndicators[i].name == 'Cobertura de la cuota') {
                        this.percentCards[0].value = storageFinancialIndicators[i].value;
                    }
                }
            }            
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
    .card-content{
        min-height: 85px
    }
</style>
